/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table } from "antd";

const Datatable = ({
  props,
  columns,
  dataSource,
  pgno = false,
  showSizeChangerProp = true,
}) => {
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleSearch = (value) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const finalColumns = pgno
    ? [
        {
          title: "S.No",
          dataIndex: "pgno",
          width: 80,
          render: (_, __, index) =>
            (pagination.current - 1) * pagination.pageSize + (index + 1),
        },
        ...columns,
      ]
    : columns;

  return (
    <>
      <div className="search-set table-search-set">
        <div className="search-input">
          <a href="#" className="btn btn-searchset">
            <i className="ti ti-search fs-14 feather-search" />
          </a>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {" "}
              <input
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
              />
            </label>
          </div>
        </div>
      </div>

      <Table
        key={props}
        className="table datanew dataTable no-footer"
        columns={finalColumns}
        dataSource={filteredDataSource}
        rowKey={(record) => record.id}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: (
            <span>
              <i className="fa fa-angle-right" />
            </span>
          ),
          prevIcon: (
            <span>
              <i className="fa fa-angle-left" />
            </span>
          ),
          defaultPageSize: 10,
          showSizeChanger: showSizeChangerProp,
          pageSizeOptions: ["10", "20", "30"],
          showLessItems: true,
        }}
      />
    </>
  );
};

export default Datatable;
